module.exports = __webpack_public_path__ + "img/emogi.af93f19f.png";